import {
  Clonable,
  FeedItemMetadata,
  FeedItemMetadataWithLocation,
  getMimeTypeFromFile,
  isNonEmptyString,
  isNumber,
  Kind,
  ServiceProvider,
} from '../../..';

export type FeedItemWithCaption = FeedItem & { caption: string };
export type FeedItemWithLocation = FeedItem & { metadata: FeedItemMetadataWithLocation };

export class FeedItem extends Clonable {
  public readonly kind: Kind;

  constructor(
    public readonly id: string,
    public readonly caption: string | undefined,
    public readonly createdAt: Date,
    public readonly driveId: string | undefined,
    public readonly fileId: string,
    public readonly fileName: string,
    public readonly folderId: string,
    public readonly folderName: string,
    public readonly albumId: string,
    public readonly metadata: FeedItemMetadata | undefined,
    public readonly mime: string,
    public readonly provider: ServiceProvider,
    public readonly tags: readonly string[],
    public readonly teamId: string,
    public readonly uploadedAt: Date | undefined,
    public readonly uploadedBy: string,
    public readonly publicUrl: string | undefined = undefined,
    public readonly publicLargeUrl: string | undefined = undefined,
    public readonly publicThumbUrl: string | undefined = undefined,
    public readonly galleryRefs: readonly string[] = [],
  ) {
    super();

    // Get the MIME type kind
    const mimeType = getMimeTypeFromFile(fileName);
    this.kind = mimeType?.kind ?? Kind.Unknown;
  }

  public hasCaption(): this is FeedItemWithCaption {
    return isNonEmptyString(this.caption);
  }

  public hasGeoLocation(): this is FeedItemWithLocation {
    return isNumber(this.metadata?.latitude) && isNumber(this.metadata?.longitude);
  }

  public hasTags(): boolean {
    return this.tags.length > 0;
  }
}
